import { Wrench, Flame, Zap, Microwave, Utensils, Fan, Thermometer, Hammer, ArrowRight, PhoneCall, Mail } from 'lucide-react';
import {
  Brain,
  Heart,
  Smile,
  Users,
  Layers,
  Focus,
  Shield,
  Home,
} from "lucide-react";
import { useNavigate } from 'react-router-dom';

const services = [
  {
    icon: <Brain size={28} />,
    title: "Cognitive Behavioral Therapy (CBT)",
    desc: "A structured, goal-oriented therapy that helps individuals identify and change negative thought patterns and behaviors, replacing them with healthier coping strategies.",
  },
  {
    icon: <Smile size={28} />,
    title: "Behavior Therapy",
    desc: "Focuses on modifying harmful or unhelpful behaviors through practical techniques such as reinforcement, exposure, and skills training to encourage positive change.",
  },
  {
    icon: <Focus size={28} />,
    title: "Mindfulness-Based Cognitive Therapy (MBCT)",
    desc: "Combines cognitive therapy with mindfulness practices, helping individuals become more aware of their thoughts and emotions while responding calmly instead of reacting impulsively.",

  },
  {
    icon: <Heart size={28} />,
    title: "Person-Centered Approaches",
    desc: "A supportive, empathetic, and non-judgmental form of therapy where clients are encouraged to explore their feelings and experiences at their own pace, fostering personal growth and self-acceptance.",

  },
  {
    icon: <Layers size={28} />,
    title: "Eclectic Approaches",
    desc: "An integrative method that draws from multiple therapeutic models, tailoring techniques to meet the unique needs and goals of each individual.",

  },
  {
    icon: <Shield size={28} />,
    title: "Dialectical Behavior Therapy (DBT)",
    desc: "A specialized form of therapy that combines cognitive and behavioral strategies with mindfulness, designed to help individuals regulate emotions, improve relationships, and manage distress effectively.",

  },
  {
    icon: <Brain size={28} />,
    title: "Trauma-Focused Therapy",
    desc: "Specifically designed to help individuals process and heal from the emotional impact of traumatic experiences, building resilience and restoring a sense of safety and control.",

  },
  {
    icon: <Users size={28} />,
    title: "Family Therapy",
    desc: "A collaborative approach that involves family members in the healing process, strengthening communication, resolving conflicts, and fostering healthier relationships within the family unit.",

  },
];


const HomeServices = () => {
  const navigate = useNavigate()
  return (
    <section className="hob-services-section">
      <div className="hob-services-header">
        <h2 className="hob-services-heading">Therapy Sessions</h2>
        <p className="hob-services-subtext">
          Expert therapy sessions designed to support your mental and emotional well-being.
        </p>
      </div>
      <div className="hob-services-grid">
        {services.map((service, idx) => (
          <div className="hob-service-card" key={idx}>
            <div className="hob-service-icon">{service.icon}</div>
            <h3 className="hob-service-title">{service.title}</h3>
            <p className="hob-service-desc">{service.desc}</p>
            <div className="hob-service-actions">
              <span
                className="hob-service-link"
                onClick={() => navigate('/book-session')}
                style={{ cursor: "pointer" }}
              >
                Book session <ArrowRight size={14} />
              </span>
              <span
                className="hob-service-link"
                onClick={() => (window.location.href = "mailto:khandolrutika@gmail.com")}
                style={{ cursor: "pointer" }}
              >
                <Mail size={14} /> Email Us
              </span>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeServices;
